export var LIVE_SUBSCRIPTION_TRANSLATION_KEY = 'live-subscription';